import React, { Component } from 'react'
import { connect } from 'react-redux'
import { getAllOrders } from '../../../redux/actions/orderActions'
import { whoIs } from '../../../redux/actions/miscActions'
import OrdersTable from '../ulits/OrdersTable'
import ProductsOnSaleTable from '../ulits/ProductsOnSaleTable'
import DashboardCards from '../ulits/DashboardCards'

export class Dashboard extends Component {
 whoIs=()=>{
  this.props.whoIs()
 }
  render() {
    const { orders } = this.props.order
    const { allClientProducts } = this.props.products

    const lastTenOrders = orders.filter(x => x.status === 'pending').sort((a, b) => b.date.toDate() - a.date.toDate()).slice(0, 10)

    const productsOnSale = allClientProducts.filter(x => x.isVisible === true).filter(x => x.productOnSale === true)

    const ordersOptions = {pagination: false,
      dataSource: lastTenOrders,
      locale: {emptyText: 'Geen lopende bestellingen'}
    }
    
    const salesTableOptions = {pagination: false,
      dataSource: productsOnSale,
      locale: {emptyText: 'Geen producten on sale'}}
    
    return (
      <div className="admin-dashboard">
        <div className="admin-dashboard-content">
          <DashboardCards orders={orders} products={allClientProducts} productsOnSale={productsOnSale} />
          <h4>Nieuwste bestellingen</h4>
          <OrdersTable {...ordersOptions} />
          <h4>Producten on Sale</h4>
          <ProductsOnSaleTable {...salesTableOptions} />
        </div>
       
      </div>
    )
  }
}

const mapStateToProps =(state)=>({
  order: state.order,
  products: state.products,
  cart: state.cart,
})

export default connect(mapStateToProps, { getAllOrders, whoIs })(Dashboard)
